"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHeartFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.56 6.54A7.42 7.42 0 0022.26 4c-2 0-4.08 1-6.26 3-2.17-2-4.23-3-6.26-3a7.4 7.4 0 00-5.3 2.54C1.92 9.1.09 13.34 5.7 19.05l10.3 9.3L26.35 19c5.56-5.66 3.73-9.9 1.21-12.46z" })));
}
exports.default = SvgHeartFilled;
//# sourceMappingURL=HeartFilled.js.map